import React from 'react'
import DocCode from '../DocCode'
import CategoryPreviewData from './Components/CategoryPreviewData'

const CategoryPreviews = () => {

    // {/* x---------------------------------x Catagory Code Section x---------------------------------x */}s
    const CategoryPreviewCode =
        `
        <!--
            This example requires some changes to your config:

            // tailwind.config.js
                module.exports = {
                    // ...
                    plugins: [
                        // ...
                        require('@tailwindcss/aspect-ratio'),
                    ],
                }
        -->

    <div className="bg-gray-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-2xl py-16 sm:py-24 lg:max-w-none lg:py-32">
            <h2 className="text-2xl font-bold text-gray-900">Collections</h2>

                <div className="mt-6 space-y-12 lg:grid lg:grid-cols-3 lg:gap-x-6 lg:space-y-0">
                    <div className="group relative">
                        <div className="relative h-80 w-full overflow-hidden rounded-lg bg-white sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 group-hover:opacity-75 sm:h-64">
                            <img src="https://tailwindui.com/plus/img/ecommerce-images/home-page-02-edition-01.jpg" alt="Desk with leather desk pad, walnut desk organizer, wireless keyboard and mouse, and porcelain mug." className="h-full w-full object-cover object-center">
                        </div>
                    <h3 className="mt-6 text-sm text-gray-500">
                        <Link to="/">
                        <span className="absolute inset-0"></span>
                        Desk and Office
                        </Link>
                    </h3>
                    <p className="text-base font-semibold text-gray-900">Work from home accessories</p>
                    </div>
                    <div className="group relative">
                        <div className="relative h-80 w-full overflow-hidden rounded-lg bg-white sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 group-hover:opacity-75 sm:h-64">
                            <img src="https://tailwindui.com/plus/img/ecommerce-images/home-page-02-edition-02.jpg" alt="Wood table with porcelain mug, leather journal, brass pen, leather key ring, and a houseplant." className="h-full w-full object-cover object-center">
                        </div>
                    <h3 className="mt-6 text-sm text-gray-500">
                        <Link to="/">
                        <span className="absolute inset-0"></span>
                        Self-Improvement
                        </Link>
                    </h3>
                    <p className="text-base font-semibold text-gray-900">Journals and note-taking</p>
                    </div>
                    <div className="group relative">
                        <div className="relative h-80 w-full overflow-hidden rounded-lg bg-white sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 group-hover:opacity-75 sm:h-64">
                            <img src="https://tailwindui.com/plus/img/ecommerce-images/home-page-02-edition-03.jpg" alt="Collection of four insulated travel bottles on wooden shelf." className="h-full w-full object-cover object-center">
                        </div>
                    <h3 className="mt-6 text-sm text-gray-500">
                        <Link to="/">
                        <span className="absolute inset-0"></span>
                        Travel
                        </Link>
                    </h3>
                    <p className="text-base font-semibold text-gray-900">Daily commute essentials</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

        `

    return (
        // {/* x---------------------------------x DocCode Component Section x---------------------------------x */}
        <DocCode
            heading={"Category Previews"}
            headingText={"Use these Tailwind CSS category preview components to highlight various product categories, and help customers find out what products are available in your store. These components are designed and built by the Tailwind CSS team, and include a variety of different styles and layouts."}
            code={CategoryPreviewCode}
            // {/* x---------------------------------x Catagory Preview Section x---------------------------------x */}
            Preview={<CategoryPreviewData />}
        />
    )
}

export default CategoryPreviews